import { render, staticRenderFns } from "./tours.vue?vue&type=template&id=8f6aae9c&scoped=true&"
import script from "./tours.vue?vue&type=script&lang=js&"
export * from "./tours.vue?vue&type=script&lang=js&"
import style0 from "./tours.vue?vue&type=style&index=0&id=8f6aae9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6aae9c",
  null
  
)

export default component.exports